import { JSX } from 'react';
import { C04MultibuttonlayoutCTAProps } from './C04MultibuttonlayoutCTA.types';
import { MultiButton } from '@ahc-digital/component-library';
import { GetMultibuttonlayoutCTAModel } from './C04MultibuttonlayoutCTA.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C04MultibuttonlayoutCTAProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <MultiButton
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...GetMultibuttonlayoutCTAModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C04MultibuttonlayoutCTAProps>(Default);
